'use strict';
import * as $j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dDocument$002dNumber$0024 from "./app.data.data_point_types$package$-Document-Number$.js";
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNumberForm$() {
  this.aJ7 = null;
  this.aJk = null;
  this.aJc = null;
  this.aJd = false;
  this.aJi = null;
  this.aJj = false;
  this.aJ8 = null;
  this.aJ9 = false;
  this.aJg = null;
  this.aJh = false;
  this.aJe = null;
  this.aJf = false;
  this.aJa = null;
  this.aJb = false;
  $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNumberForm$ = this;
  this.aJ7 = $j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dDocument$002dNumber$0024.$m_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNumber$();
  this.aJk = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_neotype\uff3fchimney$package$().eU($j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dDocument$002dNumber$0024.$m_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNumber$());
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNumberForm$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNumberForm$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNumberForm$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNumberForm$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNumberForm$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNumberForm$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNumberForm$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNumberForm$.prototype = $p;
$p.eR = (function() {
  return this.aJ7;
});
$p.eO = (function() {
  return this.aJk;
});
$p.b9 = (function() {
  if ((!this.aJd)) {
    this.aJc = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1(this);
    this.aJd = true;
  }
  return this.aJc;
});
$p.b3 = (function() {
  if ((!this.aJj)) {
    this.aJi = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5(this);
    this.aJj = true;
  }
  return this.aJi;
});
$p.aG = (function() {
  if ((!this.aJ9)) {
    this.aJ8 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6(this);
    this.aJ9 = true;
  }
  return this.aJ8;
});
$p.az = (function() {
  if ((!this.aJh)) {
    this.aJg = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_UnvalidatedNewtypeOf__partialTransformer__Lio_scalaland_chimney_PartialTransformer(this);
    this.aJh = true;
  }
  return this.aJg;
});
$p.aY = (function() {
  if ((!this.aJf)) {
    this.aJe = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_Validatable$().eS(this.az());
    this.aJf = true;
  }
  return this.aJe;
});
$p.bN1 = (function() {
  if ((!this.aJb)) {
    this.aJa = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Document Number";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aJb = true;
  }
  return this.aJa;
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNumberForm$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNumberForm$, "app.data.data_point_types$package$DocumentNumberForm$", ({
  FI: 1,
  N: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNumberForm$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNumberForm$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNumberForm$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNumberForm$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNumberForm$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNumberForm$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNumberForm$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNumberForm$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNumberForm$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$DocumentNumberForm$ };
//# sourceMappingURL=app.data.data_point_types$package$-Document-Number-Form$.js.map
